import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { TenantHubService } from './tenant-hub.service';

/**
 * Resolves the tenant's name for the breadcrumb (`Tenanti › <name> › …`). Wired on the `tenanti/:tenantId` shell
 * route as `resolve: { tenantName: tenantNameResolver }`; the breadcrumb reads it via `data.breadcrumbResolve`.
 * Falls back to a generic label so a failed lookup never blocks navigation.
 */
export const tenantNameResolver: ResolveFn<string> = async (route: ActivatedRouteSnapshot) => {
    const tenantId = route.paramMap.get('tenantId');
    if (!tenantId) return 'Tenant';
    try {
        const header = await inject(TenantHubService).header(tenantId);
        return header.name;
    } catch {
        return 'Tenant';
    }
};
